import './import';
import '../scss/styles.scss';
import '../css/index.css';
import '../css/fonts.css';
import 'pixi-spine';
import './utils/flashlibExtantion';
// import './libs/fullscreen/fullscreen';
import './utils/number';
import { createStore, compose } from 'redux';
import reducer from './redux/reducers';
import StoreObserver from './redux/storeObserver';
import Game from './controllers/controllerGame';

const devtools = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
const composer = devtools ? devtools : compose;

// export const store = createStore(reducer, composer(applyMiddleware(logger)));
export const store = createStore(reducer);

export const storeObserver = new StoreObserver(store);

export const game = new Game();
